module.exports = "/assets/47ae2aa95138355d46abab201c8816b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/J9.png
// module id = 2626
// module chunks = 0